import { GenerateButtonProps } from 'components/Wizards/Field/Types'
import { useField } from 'formik'
import { GenerateButton } from './GenerateButton'
import { GenerateMoreButton } from './GenerateMoreButton'

export const DynamicGenerateButton = ({ field: fieldName, ...props }: GenerateButtonProps) => {
  const [field] = useField(fieldName)

  if (field.value.length < 1) {
    return <GenerateButton field={fieldName} {...props} />
  }

  return <GenerateMoreButton field={fieldName} {...props} />
}
